
export {
    all,
}


const all = `/all`;
